import firebase from 'firebase';
import * as firebaseui from 'firebaseui';

const ui = new firebaseui.auth.AuthUI(firebase.auth());

export default ui;



// WEBPACK FOOTER //
// ./src/firebase/ui.js